// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees",
  ListShort: "/pyr/employees/short",
  Detail: "/pyr/employees",
  Create: "/pyr/employees",
  Update: "/pyr/employees",
  Import: "/pyr/employees/import",
  GetTotalEmployee: "/pyr/payrolls/get-total-employee",
  WorkingHistory: "/pyr/employees/{employeeId}/working-history",
};
